<ng-container *mobxAutorun>
  <ng-container *ngIf="shouldDisplay">
    <!-- Label -->
    <span *ngIf="label" class="label">{{ label }}</span>
    <lf-help-tooltip *ngIf="helpMessage" [help]="helpMessage"></lf-help-tooltip>

    <!-- Required icon -->
    <lf-icon
      class="is-required"
      icon="asterisk"
      *ngIf="showIsRequired && !isReadOnly"
    ></lf-icon>

    <!-- Pending validation -->
    <div
      class="status pending"
      *ngIf="relativeStorage.shouldShowPending()"
    ></div>
    <!-- Rejected validation -->
    <div
      class="status rejected"
      *ngIf="relativeStorage.shouldShowRejected()"
      (click)="relativeStorage.recomputeStateProperties()"
    >
      <lf-tooltip [help]="retryValidateText">
        <lf-icon icon="warning"></lf-icon>
      </lf-tooltip>
    </div>

    <!-- (Debug) value state -->
    <lf-value-state [path]="path"></lf-value-state>

    <!-- Input group -->
    <div
      class="input-group input-group-sm"
      [class.is-warning]="relativeStorage.shouldShowWarning()"
      [class.is-invalid]="relativeStorage.shouldShowError()"
    >
      <!-- Code -->
      <div *ngIf="code" class="input-group-prepend">
        <div class="input-group-text">{{ code }}</div>
      </div>

      <!-- File input -->
      <div class="custom-file" [title]="_selectedFile?.name || noneChosenText">
        <input
          #focusTarget
          type="file"
          [accept]="accept"
          [id]="_id"
          class="custom-file-input"
          [attr.aria-describedby]="_id"
          [class.is-warning]="relativeStorage.shouldShowWarning()"
          [class.is-invalid]="relativeStorage.shouldShowError()"
          [class.is-readonly]="isReadOnly"
          [name]="path"
          [disabled]="isReadOnly"
          (input)="_onInput($event)"
          (focus)="_onFocus($event)"
          (blur)="_onBlur($event)"
        />
        <label
          class="custom-file-label"
          [attr.for]="_id"
          [attr.data-browse]="browseText"
        >
          <span
            class="custom-file-label-content"
            [class.placeholder]="!_selectedFile"
            >{{ _selectedFile?.name || choosePlaceholder }}</span
          >

          <!-- Clear button -->
          <button
            *ngIf="_selectedFile && !isReadOnly"
            type="button"
            class="close"
            [title]="clearButtonTooltip"
            [attr.aria-label]="clearButtonTooltip"
            (click)="_onClickClear($event)"
          >
            <span aria-hidden="true">×</span>
          </button>

          <!-- Browse text -->
          <div class="browse-text">{{ browseText }}</div>
        </label>
      </div>
    </div>

    <!-- Legend -->
    <div *ngIf="legend" class="legend">{{ legend }}</div>
  </ng-container>
</ng-container>
